export default __webpack_public_path__ + "static/media/xmark-solid.fd192dfa.svg";